import React, {useReducer} from 'react'
import {connect} from "react-redux";
import {setSQFTActiveButton} from "../../../../actions/sqftMenuFunctions";
import {injectIntl} from "react-intl";
import {setActiveSlabId, setActiveSlabUrl} from "../../../../actions/sqftSlabFunctions";
import FeatureThumbnail from "../../../visComponents/featureThumbnail";
import FeatureName from "../../../visComponents/featureName";
import AllFeaturesChecker from "../../../visComponents/allFeaturesChecker";
import {getNavItems} from "../../helpers/sqftHelperUi";
import {getCountertopFeatureGroup, getCurrentLayout} from "../../../appLayout";

const SqftStepSelectSlab = (props) => {
  const {setActiveSlabId} = props;
  const {searchText, activeSlabId} = props;
  const [, forceUpdate] = useReducer(x => x + 1, 0);
  const featureGroup = getCountertopFeatureGroup(getCurrentLayout());
  const navItems = getNavItems(featureGroup, searchText, {}, true, true);

  const handleSelectSlab = (feature) => {
    setActiveSlabId(feature.part.dbFeature.id);
    //setActiveSlabUrl(feature.part.dbFeature.galleryImages[0].url);
  };

  return (
    <div className={"slab-content"}>
      <ul className="slab-list">
        {featureGroup && featureGroup.part && !featureGroup.part.allFeaturesReceived
          ? <AllFeaturesChecker subPart={featureGroup} callBack={() => forceUpdate(1)} loaderOnly={true}/>
          : navItems
            .map((feature) => {
              return <li key={feature.part.dbFeature.id}
                         className={"slab-list__item " + (activeSlabId === feature.part.dbFeature.id ? "slab-list__item--active":"")}
                         onClick={() => handleSelectSlab(feature)}
              >
                <FeatureThumbnail feature={feature.part}/>
                <div className="slab-list__item-name">
                  <FeatureName feature={feature.part}/>
                </div>
              </li>
            })
        }
      </ul>
    </div>
  )
};

const mapStateToProps = (store) => ({
  activeButton: store.sqftMenuState.activeButton,
  activeSlabId: store.sqftSlabState.activeSlabId,
  searchText: store.sqftSlabState.searchText,
});

const mapDispatchToProps = {
  setSQFTActiveButton,
  setActiveSlabId,
  setActiveSlabUrl,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftStepSelectSlab)
)

